module.exports = __webpack_public_path__ + "static/media/Bicocca - white_GR Green.1f14c25b.jpg";